import React, { Component, useRef, useEffect, useState, createContext } from 'react';

const DutyCheckContext = createContext(false);
// console.log('DutyCheckContext created : ', DutyCheckContext);
export default DutyCheckContext;